/**
 * Makes Vite's import.meta available on globalThis so modules like api.ts can
 * resolve the API base URL without using the `import.meta` token (Jest cannot parse it).
 * Import this as the first side-effect in main.tsx.
 */
(globalThis as {
  importMeta?: {
    env?: ImportMetaEnv;
  };
}).importMeta = {
  env: import.meta.env,
};
